import axios from 'axios'
import { checkToken } from '@/helpers'
import { logError } from './bugsnag'

const apiUrls = {
  API: process.env.VUE_APP_API_URL,
  BUSINESS: process.env.VUE_APP_BUSINESS_URL,
  CONTENT: process.env.VUE_APP_CONTENT_URL,
  EXERCISES: process.env.VUE_APP_EXERCISES_URL,
  FILES: process.env.VUE_APP_FILES_URL,
  IFRAME: process.env.VUE_APP_IFRAME_URL,
  PROFILE: process.env.VUE_APP_PROFILE_URL,
  QUIZ: process.env.VUE_APP_QUIZ_URL,
  STATISTICS: process.env.VUE_APP_STATISTICS_URL,
  SUBSCRIPTIONS: process.env.VUE_APP_SUBSCRIPTIONS_URL,
  UAA: process.env.VUE_APP_UAA_URL,
  VIDEOS: process.env.VUE_APP_VIDEOS_URL,
  MIXPANEL: process.env.VUE_APP_MIXPANEL_PROXY_URL,
}

const setup = {
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    common: {
      'Content-Type': 'application/json; charset=utf-8',
    },
    post: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  },
}

const applyDefaultRequestInterceptors = clients => {
  clients.map(client => {
    client.interceptors.request.use(async config => {
      const request = await checkToken(config)

      return request
    })
    client.interceptors.response.use(
      response => response,
      error => {
        logError(error)
        throw error
      }
    )
  })
}

const API = axios.create({
  baseURL: apiUrls.API,
  ...setup,
  headers: {
    Accept: 'application/json; version=2.0.0',
  },
})
const BUSINESS = axios.create({ baseURL: apiUrls.BUSINESS, ...setup })
const CONTENT = axios.create({ baseURL: apiUrls.CONTENT, ...setup })
const EXERCISES = axios.create({ baseURL: apiUrls.EXERCISES, ...setup })
const FILES = axios.create({ baseURL: apiUrls.FILES, ...setup })
const IFRAME = axios.create({
  baseURL: apiUrls.IFRAME,
  ...setup,
  withCredentials: true,
})
const PROFILE = axios.create({ baseURL: apiUrls.PROFILE, ...setup })
const QUIZ = axios.create({ baseURL: apiUrls.QUIZ, ...setup })
const STATISTICS = axios.create({ baseURL: apiUrls.STATISTICS, ...setup })
const SUBSCRIPTIONS = axios.create({ baseURL: apiUrls.SUBSCRIPTIONS, ...setup })
const UAA = axios.create({ baseURL: apiUrls.UAA, ...setup })
const VIDEOS = axios.create({ baseURL: apiUrls.VIDEOS, ...setup })
const MIXPANEL = axios.create({ baseURL: apiUrls.MIXPANEL, ...setup })

applyDefaultRequestInterceptors([
  BUSINESS,
  CONTENT,
  EXERCISES,
  FILES,
  IFRAME,
  PROFILE,
  QUIZ,
  STATISTICS,
  SUBSCRIPTIONS,
  UAA,
  VIDEOS,
  MIXPANEL,
])

export {
  API,
  BUSINESS,
  CONTENT,
  EXERCISES,
  FILES,
  IFRAME,
  PROFILE,
  QUIZ,
  STATISTICS,
  SUBSCRIPTIONS,
  UAA,
  VIDEOS,
  MIXPANEL,
}
